import _ from 'lodash'
import { GetTreeNode } from '../../utilities/TreeHelper'
import { ACTIVE_TREE, CURRENT_LOCATION, GET_MULTI_LOCATION_TREE, GET_TREE_BY_LOCATION_ID, HAS_LOCATION_CHANGED, LEVEL_TYPES, SELECTED_TREENODE, SET_AVAILABLE_BEDS, SET_BEDS, SET_BUILDINGS, SET_EXPANDED_KEYS, SET_PARENTS, SET_PARENTS_IN_HIERARCHY, SET_PARENT_TYPES, SET_ROOMS, SET_TOTAL_BEDS, SET_TYPE } from "../actions/HierarchyAction"

const initialState = {
    allTree:[], 
    activeTree:[], 
    parentsInHierarchy:[], 
    buildings:[],
    parentTypes:[],
    parents:[],
    rooms:[],
    levelType:{ isBuilding: false, isFloor: false, isWing: false, isUnit: false, isRoom: false }, 
    filteredLevelTypes:[] ,
    selectedTreeNode:{} ,
    currentLocation:{},
    locationChangeDetail:[],
    expandedKeys:[{}, {}, {}],
    totalBeds:0,
    availableBeds:0
}

const HierarchyReducer = (state = initialState, action)=>{
    switch(action.type){
    case GET_MULTI_LOCATION_TREE: 
            if(_.gt(action.tree.length, 0))     
                return {...state, allTree:_.sortBy(action.tree, "label"), activeTree:action.tree[0], selectedTreeNode:GetTreeNode(action.tree[0],action.tree[0].key)}
            else
                return {...state, allTree:[], activeTree:[], selectedTreeNode:{}}
    case GET_TREE_BY_LOCATION_ID:      
        return {...state, allTree:_.sortBy(_.unionBy([action.tree], state.allTree, 'id'), "label"), activeTree:action.tree}
    case ACTIVE_TREE:
        return {...state, activeTree:action.tree}
    case CURRENT_LOCATION:
        var treeIndex = _.findIndex(state.allTree, t=>_.isEqual(t.id, action.location.id))        
        return {...state, activeTree:state.allTree[treeIndex], currentLocation:action.location}
    case LEVEL_TYPES:
        return {...state, filteredLevelTypes:action.levelTypes}
    case SET_PARENTS_IN_HIERARCHY:
        return {...state, parentsInHierarchy:action.parentsInHierarchy }
    case SET_BUILDINGS:
        return {...state, buildings:action.buildings}
    case SET_PARENT_TYPES:
        return {...state, parentTypes: action.parentTypes}  
    case SET_PARENTS:
        return {...state, parents: action.parents}  
    case SET_ROOMS:
        return {...state, rooms: action.rooms}  
    case SET_BEDS:
        return {...state, beds: action.beds}  
    case SET_TYPE:
        return {...state, levelType:action.levelType || { isBuilding: false, isFloor: false, isWing: false, isUnit: false, isRoom: false }}    
    case SELECTED_TREENODE:
        return {...state, selectedTreeNode:action.node}   
    case HAS_LOCATION_CHANGED:
        return {...state, locationChangeDetail:action.changeDetail}  
    case SET_EXPANDED_KEYS:
        var copyExpandedKeys = [...state.expandedKeys]      
        copyExpandedKeys[action.index] =  action.expandedKeys
        return {...state, expandedKeys:copyExpandedKeys}
    case SET_TOTAL_BEDS:
        return {...state, totalBeds:action.totalBeds};
    case SET_AVAILABLE_BEDS:
        return {...state, availableBeds:action.availableBeds}
    default:
        return {...state} 
    }          

}

export default HierarchyReducer;